<div fxLayout="column" fxFill fxLayoutAlign="center center">
    <mat-card-title *ngIf="lastLoggedInUser?.username === ''">
      <img src="./assets/images/logo-amco.png" alt="AMCO"><br>
    </mat-card-title>
    <div [ngClass]="routeAnimationsElements" *ngIf="lastLoggedInUser?.username !== ''">
      <br />
      <ngx-avatar [@rotatedState]='state' [name]="lastLoggedInUser?.firstName + ' ' + lastLoggedInUser?.surname"
        size="100" textSizeRatio="2" bgColor=""></ngx-avatar>
      <br />
    </div>
    <mat-card class="main-log" style="box-shadow: none; width: 100%; background: #01539d; border-radius: 26px; margin-bottom: -17px;">
      <div style="text-align: center;">
        <span style="color: #fff; font-size: 20px; text-shadow: none;">Login</span>
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="login()" class="full-width">
        <mat-card-content>
          <fieldset [disabled]="isLoading">
            <div *ngIf="lastLoggedInUser?.username === ''" fxLayout="row" fxLayoutAlign="center center">
              <mat-form-field appearance="outline" [ngClass]="routeAnimationsElements" class="full-width">
                <input matInput placeholder="Username" formControlName="username" style="color: #777777;padding-bottom: 2px;" />
                <mat-error *ngIf="loginForm.controls['username'].errors?.required">
                  Username is required
                </mat-error>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center">
              <mat-form-field appearance="outline" [ngClass]="routeAnimationsElements" class="full-width">
                <input matInput type="password" placeholder="Password" formControlName="password" style="color: #777777;padding-bottom: 2px;" />
                <mat-error *ngIf="loginForm.controls['password'].errors?.required">
                  Password is required
                </mat-error>
              </mat-form-field>
            </div>
          </fieldset>
        </mat-card-content>
        <mat-card-actions>
          <mat-list>
            <mat-list-item [ngClass]="routeAnimationsElements">
              <button fxFlex="100" mat-raised-button [color]="loginForm.valid && loginForm.dirty ? 'warn' : 'primary'" type="submit"
                [disabled]="!loginForm.valid || !loginForm.dirty || isLoading">
                LOGIN
              </button>
            </mat-list-item>
            <mat-list-item [ngClass]="routeAnimationsElements">
              <button style="font-size: 10px; color: white !important;" fxFlex="50" *ngIf="lastLoggedInUser?.username !== ''"
                (click)="clearLastUser()" [disabled]="isLoading" type="button" mat-button>
                CHANGE USER
              </button>
              <button [disabled]="isLoading"  style="font-size: 10px; color: white !important;" [fxFlex]="lastLoggedInUser?.username !== '' ? 50 : 100"
                (click)="forgotPassword()" [disabled]="isLoading" type="button" mat-button>
                FORGOT PASSWORD
              </button>
            </mat-list-item>
          </mat-list>
        </mat-card-actions>
      </form>
    </mat-card>
</div>
